import { render } from "./_404.vue?vue&type=template&id=0afada68"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./_404.vue?vue&type=style&index=0&id=0afada68&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__